import { isValid, isToday } from "date-fns";
import { DailyTask, Milestone } from "../../types/goals";
import { formatDate } from "../../lib/utils";

interface TaskItemProps {
    task: DailyTask;
    milestones: Milestone[];
}
const TaskItem = ({ task, milestones }: TaskItemProps) => {
    const isTaskToday = isValid(task.date) && isToday(task.date);
    const taskMilestone = milestones.find(m => m._id === task.milestoneId);
    return (
        <div className="flex items-start space-x-3 p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <input
                type="checkbox"
                checked={task.isCompleted}
                disabled={!isTaskToday && !task.isCompleted}
                onChange={() => { }}
                className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            />
            <div className="flex-1">
                <div className="flex items-start justify-between">
                    <div>
                        <p className="font-medium text-gray-900 dark:text-white">{task.title}</p>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                            {task.description}
                        </p>
                    </div>
                </div>
                <div className="mt-2 flex items-center justify-between">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                        {taskMilestone?.title}
                    </span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">
                        {formatDate(task.date)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TaskItem;